import React from 'react'

const FAQs = () => {
    return (
        <>
            <div className="News-title">
                <h3>Some Important FAQs</h3>
            </div>
            <div className="accordion accordion-flush" id="accordionFlushExample">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOne">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                            01. What is a  scrubber dryer?
                        </button>
                    </h2>
                    <div id="flush-collapseOne" className="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            Scrubber Dryer is a machine which cleans and dries the floor in a single pass.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                            02. How does a scrubber dryer cleans?
                        </button>
                    </h2>
                    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            Scrubber dryer has brushing system at the front and vacuum suction system at the rear. When scrubber dryer moves forward, brushing system at the front scrubs the floor with the help of water and the slurry generated after scrubbing, is then sucked by vacuum system provided at the back of the machine.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingThree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                            03. Where does dirty water go during cleaning with scrubber dryer?
                        </button>
                    </h2>
                    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            A scrubber dryer has two inbuilt tanks, one for putting fresh water and another for collecting dirty water.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFour">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                            04. Can we use detergent or floor cleaning chemical or sanitizer with these machines?
                        </button>
                    </h2>
                    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            Yes. We can mix the detergent or chemical with water in fresh water tank and use it.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFive">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                            05. How much area can a walk behind scrubber dryer, clean in an hour?
                        </button>
                    </h2>
                    <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            A walk behind scrubber dryer can clean from 1000 square meters to 2500 square meters in an hour. The range is due to different models with different capacities.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingSix">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                            06. How much area can a ride –on scrubber dryer, clean in an hour ?
                        </button>
                    </h2>
                    <div id="flush-collapseSix" className="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            A ride -on scrubber dryer can clean from 3,000 square meters to 10,000 square meters in an hour. The range is due to different models with different capacities.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingSeven">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
                            07. How can we calculate the area we have to clean ?
                        </button>
                    </h2>
                    <div id="flush-collapseSeven" className="accordion-collapse collapse" aria-labelledby="flush-headingSeven" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            There is a very simple calculation. You take length of the building/ shed/ hall to be cleaned in meters and multiply it with the width of the area/ hall/ shed. For example - if you have a factory shed which is 100m long and 50 m wide then area will be 100 x 50 = 5000 square meters.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingEight">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEight" aria-expanded="false" aria-controls="flush-collapseEight">
                            08. What is the power source for a scrubber drier?
                        </button>
                    </h2>
                    <div id="flush-collapseEight" className="accordion-collapse collapse" aria-labelledby="flush-headingEight" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            A walk behind scrubber drier can be operated either by electric cable which can be connected to available electrical point orSome walk behind scrubber dryers can be operated by rechargeable batteries.Ride- on scrubber driers can be operated using rechargeable batteries.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingNine">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseNine" aria-expanded="false" aria-controls="flush-collapseNine">
                            09. What type of batteries are used in these machines?
                        </button>
                    </h2>
                    <div id="flush-collapseNine" className="accordion-collapse collapse" aria-labelledby="flush-headingNine" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            Deep cycle traction batteries give good work time of machines in one charge. Lead Acid batteries, maintenance free batteries and lithium ion batteries can be used in the machines.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTen" aria-expanded="false" aria-controls="flush-collapseTen">
                            10. How many hours a machine can work in one time charging of batteries?
                        </button>
                    </h2>
                    <div id="flush-collapseTen" className="accordion-collapse collapse" aria-labelledby="flush-headingTen" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            Some walk behind scrubber dryer machines can work for 2 to 3 hours in one charge and Ride –on scrubber dryer machines can work for 3 to 6 hours in one charge.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingEleven">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEleven" aria-expanded="false" aria-controls="flush-collapseEleven">
                            11. What are the consumables required in scrubber dryers?
                        </button>
                    </h2>
                    <div id="flush-collapseEleven" className="accordion-collapse collapse" aria-labelledby="flush-headingEleven" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            Scrubber Dryers mainly have brushes and squeegee wipers as consumables.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwelve">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwelve" aria-expanded="false" aria-controls="flush-collapseTwelve">
                            12. Can I use this machine for my area ?
                        </button>
                    </h2>
                    <div id="flush-collapseTwelve" className="accordion-collapse collapse" aria-labelledby="flush-headingTwelve" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            For this, you can contact Kruger Vac Sales support team. They will understand your requirement and visit you if required and suggest you most suitable equipment for your application.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTherteen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTherteen" aria-expanded="false" aria-controls="flush-collapseTherteen">
                            13. What is the advantage of buying from Kruger Vac?
                        </button>
                    </h2>
                    <div id="flush-collapseTherteen" className="accordion-collapse collapse" aria-labelledby="flush-headingTherteen" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            20 years for experience in the business. <br />
                            Best Price Quality Ratio machines.<br />
                            Best in Industry after sales service and support.<br />
                            Spare Parts easily available.<br />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FAQs
